module.exports = __webpack_public_path__ + "static/media/In_Depth_Hero_Tablet_1.52119fda.png";